import * as React from 'react';

import FolderStar140 from './FolderStar140';

export const folderStar140 = () => <FolderStar140 />;

export default {
    title: 'Illustration/FolderStar140',
    component: FolderStar140,
    parameters: {
        notes: "`import FolderStar140 from 'box-ui-elements/es/illustration/FolderStar140';`",
    },
};
